var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyprojectActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9955 21H11.0045C7.90263 21 6.35168 21 5.29412 20.0894C4.23657 19.1787 4.01723 17.6544 3.57855 14.6057L3.32767 12.8621C2.98616 10.4887 2.81542 9.30206 3.30183 8.28745C3.78824 7.27284 4.82357 6.6561 6.89422 5.42263L8.14057 4.68018C10.0209 3.56006 10.9611 3 12 3C13.0389 3 13.9791 3.56006 15.8594 4.68018L17.1058 5.42263C19.1764 6.6561 20.2118 7.27284 20.6982 8.28745C21.1846 9.30206 21.0138 10.4887 20.6723 12.8621L20.4214 14.6057C19.9828 17.6544 19.7634 19.1787 18.7059 20.0894C17.6483 21 16.0974 21 12.9955 21ZM8.75782 15.1979C8.97981 14.8984 9.40255 14.8355 9.70204 15.0575C10.3575 15.5434 11.1488 15.8248 12.0001 15.8248C12.8514 15.8248 13.6426 15.5434 14.2981 15.0575C14.5976 14.8355 15.0204 14.8984 15.2424 15.1979C15.4644 15.4973 15.4015 15.9201 15.102 16.1421C14.2269 16.7908 13.1566 17.1748 12.0001 17.1748C10.8436 17.1748 9.77331 16.7908 8.89814 16.1421C8.59865 15.9201 8.53582 15.4973 8.75782 15.1979Z",
    fill: "#3091F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyprojectActive);
export default __webpack_public_path__ + "static/media/icon_myproject_active.7a4afec260347ed7250fd3dc5e53d55b.svg";
export { ForwardRef as ReactComponent };